export default __webpack_public_path__ + "static/media/ro2.68f3e280.jpg";